// extracted by mini-css-extract-plugin
module.exports = {"input":"TextInput_input__8GJmj","error":"TextInput_error__J12Pv"};